module.exports = __webpack_public_path__ + "img/recruitment.1f3b47da.png";